/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.organizationModule')
  .controller('OrganizationBulbAdminController', ['topOrganization', OrganizationBulbAdminController]);

function OrganizationBulbAdminController(topOrganization) {

  // Only use the variables we need for the admin dashboard.
  this.current = {
    topOrg: topOrganization,
    dashMetrics: topOrganization.metrics,
    id: topOrganization.id,
    item: ''
  };
}

